<template>
  <section>
    <v-card>
      <v-card-title class="chart-title" primary-title>
        School Registrations by State (%)
      </v-card-title>
      <v-select
        :items="dropDown"
        label="View month or total registrations"
        class="graphSelect pl-3 pt-4"
        v-model="dropDownSelection"
      ></v-select>
      <v-row>
        <v-col cols="12">
          <pie-chart
            :chart-data="data"
            :options="options"
            class="pa-2 chart-layout"
          />
        </v-col>
      </v-row>
    </v-card>
  </section>
</template>

<script>
import PieChart from '../charts/PieChart'
import { mapState } from 'vuex'

export default {
  components: {
    PieChart
  },
  async mounted() {
    // const items = await this.$axios.get(
    //   'api/clients/reports?type=schoolsByStatePieChart&date_start=2010-01-01&date_end=2030-01-01'
    // )
    // this.monthDataset = items['monthDataset']
    // this.overallDataset = items['overallDataset']
    // this.data = items['monthDataset']
  },
  data: () => ({
    dropDown: [
      { text: 'Registrations this month', value: 'monthDataset' },
      { text: 'Total Registrations', value: 'overallDataset' }
    ],
    dropDownSelection: 'monthDataset',
    options: {
      maintainAspectRatio: false,
      legend: {
        display: true,
        position: 'left'
      }
    },
    monthDataset: {},
    overallDataset: {}
  }),
  watch: {
    dropDownSelection(value) {
      return value == 'monthDataset'
        ? (this.data = this.monthDataset)
        : (this.data = this.overallDataset)
    }
  },
  computed: {
    ...mapState(['lessonTerm']),
    data() {
      return {
        labels: ['NSW', 'ACT', 'VIC', 'SA', 'WA', 'TAS', 'NT'],
        datasets: [
          {
            label: `${this.capitalizeFirstLetter(
              this.lessonTerm
            )} usage previous month`,
            backgroundColor: ['#900048', '#099A97', '#9764C7'],
            data: ['90', '0', '10', '0', '0', '0', '0']
          }
        ]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.chart-layout {
  height: 220px !important;
}
</style>
